import React from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  Link,
  HStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { FiMail, FiPhone } from "react-icons/fi";

const Contact = () => {
  const navigate = useNavigate();
  return (
    <Box
      minH="100vh"
      bg="radial-gradient(circle at top, #2a124f 0%, #0b0515 60%, #000 100%)"
      color="white"
      py={{ base: 16, md: 24 }}
      px={{ base: 4, md: 12 }}
      position="relative"
      overflow="hidden"
    >
      {/* Glow Background Left */}
      <Box
        position="absolute"
        top="20%"
        left="-100px"
        w={{ base: "200px", md: "350px" }}
        h={{ base: "200px", md: "350px" }}
        bg="radial-gradient(circle, #8B5CF6 0%, rgba(0,0,0,0) 70%)"
        filter="blur(120px)"
        opacity={0.7}
      />

      {/* Glow Background Right */}
      <Box
        position="absolute"
        bottom="20%"
        right="-100px"
        w={{ base: "200px", md: "350px" }}
        h={{ base: "200px", md: "350px" }}
        bg="radial-gradient(circle, #8B5CF6 0%, rgba(0,0,0,0) 70%)"
        filter="blur(120px)"
        opacity={0.7}
      />

      {/* Content */}
      <Flex
        direction="column"
        align="center"
        textAlign="center"
        maxW="1000px"
        mx="auto"
        position="relative"
        zIndex={1}
      >
        {/* Title */}
        <Text
          fontSize={{ base: "42px", sm: "60px", md: "100px" }}
          fontWeight="bold"
          bgGradient="linear(to-r, #fff , #BDA8FB)"
          bgClip="text"
          lineHeight="1"
        >
          Contact Us
        </Text>

        {/* Description */}
        <Text
          fontSize={{ base: "16px", md: "21px" }}
          opacity={0.8}
          mt={6}
          color="#A78BFA"
          px={{ base: 2, md: 0 }}
        >
          Let’s Build the Future of Gaming Together.
          We’re always ready for the next big thing. Whether you have a fresh
          business idea, a massive ad campaign, or a game you want millions of
          players to see — we want to hear from you.
        </Text>

        {/* Career Heading */}
        <Text
          fontSize={{ base: "24px", md: "40px" }}
          fontWeight="bold"
          mt={12}
        >
          Looking for your next big move?
        </Text>

        {/* Career Description */}
        <Text
          fontSize={{ base: "16px", md: "21px" }}
          opacity={0.8}
          mt={4}
          color="#A78BFA"
        >
          Join a team where growth, ambition, and community actually mean
          something. We’re always looking for experts to help us level up.
        </Text>

      

<Flex
  justify="center"
  align="center"
  gap={{ base: 4, md: 8 }}
  flexDirection={{ base: "column", md: "row" }}
  py={6}
>

  {/* Email Card */}
  <Box
    w={{ base: "100%", md: "280px" }}
    h="120px"
    bg="rgba(139,92,246,0.1)"
    border="1px solid rgba(139,92,246,0.3)"
    borderRadius="xl"
    transition="all 0.3s ease"
    _hover={{
      transform: "translateY(-6px) scale(1.03)",
      boxShadow: "0 12px 40px rgba(139,92,246,0.45)",
      borderColor: "#A78BFA",
      bg: "rgba(139,92,246,0.18)"
    }}
  >
    <Flex direction="column" justify="center" align="center" w="100%" p={{base:4, md:1}} h="100%" gap={2}>
      <FiMail size={22} color="#C4B5FD" />
      <Text fontWeight="semibold" color="white">Email</Text>
      <Link href="mailto:support@winnsta.com" color="#C4B5FD" fontWeight="bold">
        support@winnsta.com
      </Link>
    </Flex>
  </Box>

  {/* Phone Card */}
  <Box
    w={{ base: "100%", md: "280px" }}
    h="120px"
    bg="rgba(139,92,246,0.1)"
    border="1px solid rgba(139,92,246,0.3)"
    borderRadius="xl"
    transition="all 0.3s ease"
    _hover={{
      transform: "translateY(-6px) scale(1.03)",
      boxShadow: "0 12px 40px rgba(139,92,246,0.45)",
      borderColor: "#A78BFA",
      bg: "rgba(139,92,246,0.18)"
    }}
  >
    <Flex direction="column" justify="center" align="center" width="100%" h="100%" gap={2}>
      <FiPhone size={22} color="#C4B5FD" />
      <Text fontWeight="semibold" color="white">Phone</Text>
      <Link href="tel:02247790300" color="#C4B5FD" fontWeight="bold">
        02247790300
      </Link>
    </Flex>
  </Box>

</Flex>
      </Flex>
    </Box>
  );
};

export default Contact;
